import { IService } from '@/modules/interfaces';

export default class SendWsRequest implements IService<null, void> {
  async call(): Promise<void> {
    throw new Error('Not Implemented');
  }
}
